import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FiHelpCircle } from 'react-icons/fi';

import { Container } from './styles';

interface HelperProps {
  message: React.ReactNode;
}

const Helper: React.FC<HelperProps> = ({ message }) => {
  return (
    <Container data-tooltip>
      <FiHelpCircle />
      <p>{message}</p>
    </Container>
  );
};

export default Helper;
